import React from 'react';
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import { SpeedBack } from './pages/speed-back';
import Login from './third-party/auth/login';
import { Facilitator } from './pages/facilitator';
import { PairMatrix } from './pages/pair-matrix';
import { TeamPage } from './pages/team-page';
import { TeamProvider } from './team-members/team-member-context';
import { PairMatrixProvider } from './pair-matrix/pair-matrix-context';
import { Auth0ProviderWithRedirectCallback, ProtectedRoute } from './third-party/auth/auth0-provider';

import './index.css';

export const Main = () =>
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithRedirectCallback>
        <TeamProvider>
          <PairMatrixProvider>
            <Routes>
              <Route path="/*" element={<Login />} />
              <Route path="/team" element={<ProtectedRoute component={TeamPage} />} />
              <Route path="/speed-back" element={<ProtectedRoute component={SpeedBack} />} />
              <Route path="/facilitator" element={<ProtectedRoute component={Facilitator} />} />
              <Route path="/pair-matrix" element={<ProtectedRoute component={PairMatrix} />} />
            </Routes>
          </PairMatrixProvider>
        </TeamProvider>
      </Auth0ProviderWithRedirectCallback>
    </BrowserRouter>
  </React.StrictMode>